import React from 'react'
import { PrefixContext, useIndex } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'

export default function PerformanceIndicatorFields ({ year }) {
  const index = useIndex()

  const prefix = `performance_indicators.${year}_${index}`

  return (
    <PrefixContext.Provider value={prefix}>
      <Fields.Hidden name='id' fromName='id'/>
      <Fields.Hidden name='type' fromName='type' defaultValue='wage_ratio'/>
      <Fields.Hidden name='valid_from' fromName='valid_from'/>
      <Fields.Hidden name='valid_to' fromName='valid_to'/>
      <Fields.Input name='percent' fromName='percent' label={false}/>
    </PrefixContext.Provider>
  )
}
